import { render, staticRenderFns } from "./companyChooseAlert.vue?vue&type=template&id=ca22b39c&scoped=true&"
import script from "./companyChooseAlert.vue?vue&type=script&lang=js&"
export * from "./companyChooseAlert.vue?vue&type=script&lang=js&"
import style0 from "./companyChooseAlert.vue?vue&type=style&index=0&id=ca22b39c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca22b39c",
  null
  
)

export default component.exports